import { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Search as SearchIcon, ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { searchSite } from "../data/searchIndex";
import { trackEvent } from "../lib/api";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("q") || "";
  const [q, setQ] = useState(initial);
  const [results, setResults] = useState(searchSite(initial));

  useEffect(() => {
    setResults(searchSite(q));
    setParams(q ? { q } : {}, { replace: true });
    if (q.trim().length > 2) trackEvent("site_search", q.trim());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  return (
    <div>
      <PageHero variant="dark" label="Search" title="Search MATRIVON" crumbs={[{ label: "Search" }]} />
      <div className="mx-auto max-w-4xl px-5 py-14 lg:px-8">
        <div className="flex items-center border border-brand-line bg-white">
          <SearchIcon className="ml-4 h-5 w-5 text-brand-muted" />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search articles, calculators, advisory, resources…"
            data-testid="search-input"
            className="h-14 w-full bg-transparent px-3 text-base text-brand-ink outline-none placeholder:text-brand-muted"
          />
        </div>

        <div className="mt-8" data-testid="search-results">
          {q.trim() === "" ? (
            <p className="text-brand-muted">Start typing to search across the whole platform.</p>
          ) : results.length === 0 ? (
            <p data-testid="search-empty" className="text-brand-muted">No results for “{q}”. Try a different term.</p>
          ) : (
            <>
              <div className="mb-5 text-sm text-brand-muted">{results.length} result{results.length !== 1 ? "s" : ""}</div>
              <div className="grid gap-px border border-brand-line bg-brand-line">
                {results.map((r, i) => (
                  <Link key={i} to={r.to} data-testid="search-result-item" className="group flex items-start justify-between gap-4 bg-white p-5 transition-colors hover:bg-brand-blue/[0.03]">
                    <div>
                      <span className="text-xs font-semibold uppercase tracking-[0.14em] text-brand-red">{r.type}</span>
                      <h3 className="mt-1 font-heading text-lg font-bold text-brand-ink group-hover:text-brand-blue">{r.title}</h3>
                      <p className="mt-1 line-clamp-2 text-sm text-brand-muted">{r.text}</p>
                    </div>
                    <ArrowRight className="mt-1 h-5 w-5 shrink-0 text-brand-muted transition-transform group-hover:translate-x-1 group-hover:text-brand-blue" />
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
